import { faArrowDown, faArrowUp } from "@fortawesome/free-solid-svg-icons"
import { Fragment } from "react"
import { useDispatch, useSelector } from "react-redux"
import useFilter from "../../../../../hook/useFilter"
import { logActions } from "../../../../../store/log-slice"
import InfoIcon from "../../../../InfoIcon"

const Resort = (props) => {
    const { type } = props

    const { resort } = useFilter()
    let filteredlogs = useSelector((state) => state.log.filteredlogs)
    let logs = useSelector(state => state.log.logs)

    let dispatch = useDispatch()


    return <Fragment>
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowUp} onClick={() => {

            dispatch(logActions.setFilteredItems(resort(filteredlogs ?? logs, type, 'ASC')))
        }} />
        <InfoIcon style={{ cursor: 'pointer' }} icon={faArrowDown} onClick={() => {
            dispatch(logActions.setFilteredItems(resort(filteredlogs ?? logs, type, 'DESC')))
        }} />
    </Fragment>
}

export default Resort